module.exports = __webpack_public_path__ + "static/media/csrd_report2.ce96222e.svg";